import React from 'react';
import './Skills.css';

function Skills() {
  const skillCategories = [
    {
      category: 'Languages',
      icon: '💻',
      color: '#6366f1',
      skills: ['Java', 'JavaScript', 'TypeScript', 'Python', 'HTML/CSS', 'SQL']
    },
    {
      category: 'Backend',
      icon: '⚙️',
      color: '#8b5cf6',
      skills: ['Spring Boot', 'Spring Framework', 'Hibernate', 'JPA', 'Apache Kafka', 'RabbitMQ', 'Apache Storm', 'Apache Camel']
    },
    {
      category: 'Frontend',
      icon: '🎨',
      color: '#22d3ee',
      skills: ['React', 'Angular', 'TypeScript', 'REST APIs', 'GraphQL']
    },
    {
      category: 'Cloud & DevOps',
      icon: '☁️',
      color: '#34d399',
      skills: ['Kubernetes', 'Docker', 'OpenShift', 'Helm Charts', 'CI/CD', 'Jenkins', 'GitLab', 'TeamCity']
    },
    {
      category: 'Databases',
      icon: '🗄️',
      color: '#fbbf24',
      skills: ['PostgreSQL', 'MariaDB', 'SQL', 'FAISS (Vector DB)']
    },
    {
      category: 'Tools & AI/ML',
      icon: '🤖',
      color: '#f472b6',
      skills: ['Git', 'Maven', 'Postman', 'Keycloak', 'mTLS', 'Microservices', 'Distributed Systems', 'LangChain', 'Groq']
    }
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2 className="section-title reveal">Skills & Expertise</h2>
        <p className="section-subtitle reveal">
          Technologies I work with to build production-grade systems
        </p>
        
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div
              key={index}
              className="skill-card reveal"
              style={{
                '--card-accent': category.color,
                animationDelay: `${index * 0.1}s`
              }}
            >
              <div className="skill-card-header">
                <span className="skill-card-icon">{category.icon}</span>
                <h3>{category.category}</h3>
              </div>
              <div className="skill-list">
                {category.skills.map((skill, idx) => (
                  <span key={idx} className="skill-badge">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
